"use strict";
/*
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLLECTIONS = void 0;
var copy_markup_1 = __importDefault(require("../plugins/copy-markup"));
var accordion_1 = __importDefault(require("../plugins/accordion"));
var carousel_1 = __importDefault(require("../plugins/carousel"));
var collapse_1 = __importDefault(require("../plugins/collapse"));
var combobox_1 = __importDefault(require("../plugins/combobox"));
var datatable_1 = __importDefault(require("../plugins/datatable"));
var dropdown_1 = __importDefault(require("../plugins/dropdown"));
var file_upload_1 = __importDefault(require("../plugins/file-upload"));
var input_number_1 = __importDefault(require("../plugins/input-number"));
var overlay_1 = __importDefault(require("../plugins/overlay"));
var pin_input_1 = __importDefault(require("../plugins/pin-input"));
var range_slider_1 = __importDefault(require("../plugins/range-slider"));
var remove_element_1 = __importDefault(require("../plugins/remove-element"));
var scrollspy_1 = __importDefault(require("../plugins/scrollspy"));
var select_1 = __importDefault(require("../plugins/select"));
var stepper_1 = __importDefault(require("../plugins/stepper"));
var strong_password_1 = __importDefault(require("../plugins/strong-password"));
var tabs_1 = __importDefault(require("../plugins/tabs"));
var textarea_auto_height_1 = __importDefault(require("../plugins/textarea-auto-height"));
var theme_switch_1 = __importDefault(require("../plugins/theme-switch"));
var toggle_count_1 = __importDefault(require("../plugins/toggle-count"));
var toggle_password_1 = __importDefault(require("../plugins/toggle-password"));
var tooltip_1 = __importDefault(require("../plugins/tooltip"));
var tree_view_1 = __importDefault(require("../plugins/tree-view"));
exports.COLLECTIONS = [
    {
        key: 'copy-markup',
        fn: copy_markup_1.default,
        collection: '$hsCopyMarkupCollection',
    },
    { key: 'accordion', fn: accordion_1.default, collection: '$hsAccordionCollection' },
    { key: 'carousel', fn: carousel_1.default, collection: '$hsCarouselCollection' },
    { key: 'collapse', fn: collapse_1.default, collection: '$hsCollapseCollection' },
    { key: 'combobox', fn: combobox_1.default, collection: '$hsComboBoxCollection' },
    { key: 'datatable', fn: datatable_1.default, collection: '$hsDataTableCollection' },
    { key: 'dropdown', fn: dropdown_1.default, collection: '$hsDropdownCollection' },
    {
        key: 'file-upload',
        fn: file_upload_1.default,
        collection: '$hsFileUploadCollection',
    },
    {
        key: 'input-number',
        fn: input_number_1.default,
        collection: '$hsInputNumberCollection',
    },
    { key: 'overlay', fn: overlay_1.default, collection: '$hsOverlayCollection' },
    { key: 'pin-input', fn: pin_input_1.default, collection: '$hsPinInputCollection' },
    {
        key: 'range-slider',
        fn: range_slider_1.default,
        collection: '$hsRangeSliderCollection',
    },
    {
        key: 'remove-element',
        fn: remove_element_1.default,
        collection: '$hsRemoveElementCollection',
    },
    { key: 'scrollspy', fn: scrollspy_1.default, collection: '$hsScrollspyCollection' },
    { key: 'select', fn: select_1.default, collection: '$hsSelectCollection' },
    { key: 'stepper', fn: stepper_1.default, collection: '$hsStepperCollection' },
    {
        key: 'strong-password',
        fn: strong_password_1.default,
        collection: '$hsStrongPasswordCollection',
    },
    { key: 'tabs', fn: tabs_1.default, collection: '$hsTabsCollection' },
    {
        key: 'textarea-auto-height',
        fn: textarea_auto_height_1.default,
        collection: '$hsTextareaAutoHeightCollection',
    },
    {
        key: 'theme-switch',
        fn: theme_switch_1.default,
        collection: '$hsThemeSwitchCollection',
    },
    {
        key: 'toggle-count',
        fn: toggle_count_1.default,
        collection: '$hsToggleCountCollection',
    },
    {
        key: 'toggle-password',
        fn: toggle_password_1.default,
        collection: '$hsTogglePasswordCollection',
    },
    { key: 'tooltip', fn: tooltip_1.default, collection: '$hsTooltipCollection' },
    { key: 'tree-view', fn: tree_view_1.default, collection: '$hsTreeViewCollection' },
];
